var map = {
	"./cardholder.svg": "1da5",
	"./conditioner.svg": "c6fe",
	"./curtains.svg": "2788",
	"./fridge.svg": "f462",
	"./heating.svg": "19b3",
	"./humidity_sensor.svg": "fe21",
	"./leak_sensor.svg": "ed8d",
	"./light_sensor.svg": "5d65",
	"./lighting.svg": "f115",
	"./lighting_off.svg": "3576",
	"./motion_sensor.svg": "98f9",
	"./opening_sensor.svg": "856c",
	"./socket.svg": "5c7b",
	"./switch.svg": "d56b",
	"./thermometer.svg": "b2cd",
	"./tv.svg": "db6b",
	"./ventilation.svg": "9b8c",
	"./warm_floor.svg": "0934",
	"./water_shut_off.svg": "6635"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "074b";